import React from "react";
import useGetFile from "../../../hooks/useGetFile";
import useAuthCandidateToken from "../../../hooks/useAuthCandidateToken";
import BASE from "../../../config";

const PreviewButton = ({
  leagleForms,
  files,
  getLeagleFormPreviewData,
  formName
}) => {

  const photo = files?.photo || ""
  const sign = files?.sign || ""

  return (
    <button
      className="btn-sm btn-primary fw-bold d-flex"
      onClick={async (e) => {
        e.stopPropagation();
        const form = leagleForms.filter(
          (form) => form.formName === formName
        )[0];
        getLeagleFormPreviewData(form, photo, sign, "");
      }}
    >
      Preview{" "}
      <span className="pl-1">
        <i class="fa fa-eye" aria-hidden="true"></i>
      </span>
    </button>
  );
};

export default PreviewButton;
